export default class UploadInput {
    static init(): void {
        const containers = document.querySelectorAll('.upload-input');

        if (containers.length === 0) {
            return;
        }

        containers.forEach((container) => {
            const input = container.querySelector('input[type="file"]') as HTMLInputElement;
            const fileBlocksContainer = container.querySelector('.upload-input__files') as HTMLDivElement;
            const imgSrc = fileBlocksContainer.dataset.src as string;
            const dataTransfer = new DataTransfer();

            input.addEventListener('change', (ev: Event) => {
                ev.preventDefault();

                // Přidání nově vybraných souborů do objektu DataTransfer
                if (input.files) {
                    for (let i = 0; i < input.files.length; i++) {
                        dataTransfer.items.add(input.files[i]);
                    }
                }

                // Přiřazení souborů z objektu DataTransfer zpět do input.files
                input.files = dataTransfer.files;

                // Aktualizace zobrazení souborů na stránce
                updateFileBlocks(dataTransfer.files);
            });

            // Funkce pro aktualizaci zobrazení souborů na stránce
            function updateFileBlocks(files: FileList | null) {
                if (!files) {
                    return;
                }

                // Odstranění všech existujících bloků souborů
                fileBlocksContainer.innerHTML = '';

                // Vytvoření nových bloků souborů z objektu DataTransfer
                Array.from(files).forEach((file) => {
                    const newFileBlock = createFileBlock(file);
                    fileBlocksContainer.append(newFileBlock);
                });
            }

            // Funkce pro vytvoření bloku souboru
            function createFileBlock(file: File): HTMLDivElement {
                const fileBlock = document.createElement('div');
                fileBlock.classList.add('upload-input__file-block');

                const fileImg = document.createElement('img');
                fileImg.classList.add('upload-input__file-img');
                fileImg.setAttribute('src', imgSrc + file.name.split('.').pop() + '.svg');
                fileBlock.appendChild(fileImg);

                const fileName = document.createElement('span');
                fileName.classList.add('upload-input__file-name');
                fileName.textContent = file.name;
                fileBlock.appendChild(fileName);

                fileBlock.addEventListener('click', () => {
                    // Odstranění kliknutého souboru
                    removeFile(file);
                });

                return fileBlock;
            }

            // Funkce pro odstranění souboru
            function removeFile(file: File) {
                const index = Array.from(dataTransfer.files).findIndex((f) => f.name === file.name);
                if (index !== -1) {
                    // Odstranění souboru z objektu DataTransfer
                    dataTransfer.items.remove(index);

                    // Přiřazení aktualizovaného objektu DataTransfer zpět do input.files
                    input.files = dataTransfer.files;

                    // Aktualizace zobrazení souborů na stránce
                    updateFileBlocks(dataTransfer.files);
                }
            }
        });
    }
}
